import { Image as ChakraImage, ImageProps } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export const Image: React.FC<ImageProps> = ({ ...imageProps }) => {
  return (
    <ChakraImage
      height={24}
      width={32}
      fit="cover"
      borderRadius="xl"
      _hover={{ cursor: 'pointer' }}
      alt=""
      fallback={
        <ImageFallback
          height={24}
          width={32}
          borderRadius="xl"
          opacity={imageProps.opacity}
        />
      }
      {...imageProps}
    />
  );
};
